import React from 'react'
import stockimg from '../Assets/stockimg.webp'
import frigo from '../Assets/frigo.png'
import distribution from '../Assets/distribution.png'
import frigoarrow from '../Assets/frigoarrow.svg'
import frigoarrowright from '../Assets/frigoarrowright.svg'
import arrowright from '../Assets/arrowright.png'
import { useTranslation } from 'react-i18next'

const StockSection = (props) => {
    const {t, i18n} = useTranslation();
    const isRTL = i18n.language === 'ar';
  return (
    <section className={`relative w-full ${props.motherclassName} ${isRTL ? 'rtl' : 'ltr'}`}>
        <div className={props.className1}>
            <img loading="lazy" src={stockimg} alt='Stockage frigorifique' className='w-full h-full object-cover'/>
        </div>
        <div className={`${props.className2}`}>
            <div className={`w-full flex flex-col justify-center items-center ${props.className3} relative`}>
                <div className='w-full flex justify-start items-center gap-3 xs:gap-4 sm:gap-6'>
                    <div className={`flex justify-center items-center ${props.classiconpadd} bg-white rounded-full`}>
                        <img loading="lazy" src={frigo} alt='frigo' className={`${props.classicon} aspect-square object-contain`}/>
                    </div>
                    <div className={`flex flex-col justify-center items-start ${props.classGap1} ${props.classAfter}`}>
                        <div className={`absolute ${props.classAbsolute} `}>
                            <img loading="lazy" src={isRTL ? frigoarrowright : frigoarrow} alt='arrow' className="h-full"/>
                        </div>
                        <h1 className={`my-0 font-bold text-white uppercase ${props.classHeader1}`}>{t('homepage.servicesection.StockageFrigo.title1')}</h1>
                        <p className={`${props.classText1} text-white w-[90%] sm:w-[75%]`}>{t('homepage.servicesection.Distributionsection.types.title3')}</p>
                    </div>
                </div>
                <div className='w-full flex justify-start items-center gap-3 xs:gap-4 sm:gap-6'>
                    <div className={`flex justify-center items-center ${props.classiconpadd} bg-white rounded-full`}>
                        <img loading="lazy" src={distribution} alt='frigo' className={`${props.classicon} aspect-square object-contain`}/>
                    </div>
                    <div className={`flex flex-col justify-center items-start ${props.classGap1}`}>
                        <h1 className={`my-0 font-bold text-white uppercase ${props.classHeader1}`}>{t('homepage.servicesection.Distributionsection.title1')}</h1>
                        <p className={`${props.classText1} text-white w-[90%] sm:w-[75%]`}>{t('homepage.servicesection.Distributionsection.types.title2')}</p>
                    </div>
                </div>
            </div>
            <div className={`w-full flex flex-col justify-center items-start ${props.className4}`}>
                <h1 className={`my-0 font-bold text-white ${props.classHeader2}`}>{t('homepage.servicesection.DistributionStockage.header')} </h1>
                <div className='w-full flex flex-col justify-center items-start gap-2 sm:gap-3 xxl:gap-6'>
                    <div className="flex justify-start items-center gap-4">
                        <img src={arrowright} alt="arrow right" className={`h-2 sm:h-4 xxxl:h-6 ${isRTL && "rotate-180"}`} loading="lazy"/>
                        <h1 className={`my-0 font-[600] text-white ${props.classHeader3}`}>{t('homepage.servicesection.DistributionStockage.header1')} </h1>
                    </div>
                    <div className="flex justify-start items-center gap-4">
                        <img src={arrowright} alt="arrow right" className={`h-2 sm:h-4 xxxl:h-6 ${isRTL && "rotate-180"}`} loading="lazy"/>
                        <h1 className={`my-0 font-[600] text-white ${props.classHeader3}`}>{t('homepage.servicesection.DistributionStockage.header2')}</h1>
                    </div>
                    <div className="flex justify-start items-center gap-4">
                        <img src={arrowright} alt="arrow right" className={`h-2 sm:h-4 xxxl:h-6 ${isRTL && "rotate-180"}`} loading="lazy"/>
                        <h1 className={`my-0 font-[600] text-white ${props.classHeader3}`}>{t('homepage.servicesection.DistributionStockage.header3')} </h1>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default StockSection